import React from 'react';
import { Link as LinkIcon } from 'lucide-react';
import './LinkBadge.css';

/**
 * Baustein — Link-Badge.
 * Kleine Inline-Meta-Info „dieses Item ist mit X verknüpft" — Icon + Text,
 * gedimmt, kein Hintergrund. Distinkt von `Badge` (das hat Pill-BG).
 *
 * Use-Cases:
 *   - DeckTile-Footer: virtuelles Deck → physischer Binder
 *   - Wantlist-Quellen-Liste: Decks die per Link als Quelle vorausgewählt sind
 *
 * Props:
 *   children — Anzeigetext (z.B. Binder-Name)
 *   icon     — optional eigenes Icon (default: lucide `Link`)
 */
export default function LinkBadge({ children, icon: Icon = LinkIcon }) {
  return (
    <span className="link-badge">
      <Icon size={10} aria-hidden />
      <span className="link-badge__label">{children}</span>
    </span>
  );
}
